export default "https://cdn-static.gokick.com/assets/81b7a47639310ad105c767144326fc68b25cbb5d/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";